import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface headerSlice {
    menuLateral: boolean;
    menuProcessoSelecionado: boolean;
};

const initialState: headerSlice = {
    menuLateral: false,
    menuProcessoSelecionado: false,
};

const headerSlice = createSlice({
    name: 'headerSlice',
    initialState,
    reducers: {

        setSliceMenuLateral: (state, action: PayloadAction<boolean>) => {
            state.menuLateral = action.payload;
            if (action.payload) {
                state.menuProcessoSelecionado = false;
            }

        },
        toggleSliceMenuLateral: (state) => {
            let prevState = state.menuLateral;
            state.menuLateral = !state.menuLateral;
            if (state.menuLateral) {
                state.menuProcessoSelecionado = false;
            }
        },

        setSliceMenuProcessoSelecionado: (state, action: PayloadAction<boolean>) => {
            state.menuProcessoSelecionado = action.payload;
            if (action.payload) {
                state.menuLateral = false;
            }
        },

    }
});

export const { setSliceMenuLateral,
    toggleSliceMenuLateral,
    setSliceMenuProcessoSelecionado,

} = headerSlice.actions;

export default headerSlice.reducer;